// extracted by mini-css-extract-plugin
export default {"button":"hideBtn_button__rpkzk"};